import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { SkittleManager } from '../../services/skittle.manager';
import { ColorPicker } from '../../utils/color.picker';
import { cloneDeep } from 'lodash';

@Component({
   components: {
   }
})
export default class Skittle extends Vue {
   public title: string = 'Skittle';

   public manager: SkittleManager = new SkittleManager();

   public model: any = new SkittleManager().getSkittleConfig('default');

   public hoverModel: any = new SkittleManager().getSkittleConfig('default');

   public isHover: boolean = false;

   public borderColor = {
      'background-color': new SkittleManager().getSkittleConfig('default')!.color
   };

   public innerColor = {
      'background-color': ColorPicker.darker(new SkittleManager().getSkittleConfig('default')!.color)
   };

   public iconColor = {
      'color': ColorPicker.lighter(new SkittleManager().getSkittleConfig('default')!.color)
   };

   @Prop()
   public type: any;

   @Watch('isHover', { immediate: true, deep: true })
   public onHover(val: any, oldVal: any) {
      if (val) {
         // this.borderColor = { 'background-color': this.hoverModel.color };
         this.innerColor = { 'background-color': ColorPicker.darker(this.hoverModel.color) };
         this.iconColor = { 'color': ColorPicker.lighter(this.hoverModel.color) };
      } else {
         // this.borderColor = { 'background-color': this.model.color };
         this.innerColor = { 'background-color': ColorPicker.darker(this.model.color) };
         this.iconColor = { 'color': ColorPicker.lighter(this.model.color) };
      }
   }

   public created() {
      this.model = cloneDeep(this.manager.getSkittleConfig(this.type));
      this.model.color = ColorPicker.mixOne(this.model.color);
      if (this.model.name === 'my-frontstore') {
         this.model.name = 'my-website';
      }
      this.hoverModel = cloneDeep(this.model);
      this.hoverModel.color = ColorPicker.hover(this.hoverModel.color);
      this.borderColor = { 'background-color': this.model.color };
      this.innerColor = { 'background-color': ColorPicker.darker(this.model.color) };
      this.iconColor = { 'color': ColorPicker.lighter(this.model.color) };
   }

   public nav() {
      if (this.model.linkType === 'hyperLink') {
         window.open(this.model.link);
      } else {
         this.$router.push(this.model.link);
      }
   }
}
